<template>
  <div class="order-list-page">
    <div class="order-header">
      <i class="el-icon-arrow-left" @click="goBack"></i>
      <span class="header-title">我的订单</span>
    </div>

    <div class="order-content">
      <!-- 加载骨架屏 -->
      <div v-if="loadingSkeleton" class="skeleton-list">
        <div v-for="i in 3" :key="i" class="skeleton-item">
          <van-skeleton :row="4" />
        </div>
      </div>

      <!-- 订单列表 -->
      <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          v-else-if="orderList.length > 0"
      >
        <div class="order-list">
          <div
              v-for="(order, index) in orderList"
              :key="index"
              class="order-card"
          >
            <div class="card-header">
              <span class="order-name">{{ order.spmc }}</span>
              <span class="order-status" :class="getStatusClass(order.ddzt)">
                {{ getStatusText(order.ddzt) }}
              </span>
            </div>
            <div class="card-divider"></div>
            <div class="card-body">
              <div class="info-row">
                <span class="info-label">订单编号：</span>
                <span class="info-value">{{ order.ddbh }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">会员时长：</span>
                <span class="info-value">{{ getMemberDays(order.spmc) }}天</span>
              </div>
              <div class="info-row">
                <span class="info-label">价格：</span>
                <span class="info-value price">{{ order.ddjg }}元</span>
              </div>
            </div>
            <div class="card-divider"></div>
            <div class="card-footer">
              <span class="order-time">{{ formatDate(order.cjrq) }}</span>
              <div class="action-buttons">
                <van-button
                    v-if="order.ddzt === 1"
                    size="small"
                    type="primary"
                    class="pay-btn"
                    @click="handlePayment(order)"
                >
                  支付
                </van-button>
                <van-button
                    v-if="order.ddzt === 1"
                    size="small"
                    class="cancel-btn"
                    @click="handleCancel(order)"
                >
                  取消
                </van-button>
                <van-button
                    v-if="order.ddzt === 3"
                    size="small"
                    class="buy-again-btn"
                    @click="againPay"
                >
                  再次购买
                </van-button>
                <van-button
                    v-if="order.ddzt === 3"
                    size="small"
                    class="delete-btn"
                    @click="handleDelete(order)"
                >
                  删除
                </van-button>
              </div>
            </div>
          </div>
        </div>
      </van-pull-refresh>

      <!-- 空状态 -->
      <van-empty
          v-else
          description="暂无订单列表"
          class="empty-state"
      />
    </div>

    <!-- 支付弹窗 -->
    <VipPaymentModal
        ref="payDialog"
        :memberInfo="selectedItem"
        @load="loadOrderList"
    />
  </div>
</template>

<script>
import { orderQueryMy, orderUpdate } from '@/api/vip'
import { Toast, Dialog } from 'vant'
import VipPaymentModal from '@/components/pay/VipPaymentModal.vue'

export default {
  name: 'orderList',
  components: {
    VipPaymentModal: (resolve) => {
      require(["@/components/pay/VipPaymentModal.vue"], resolve);
    },
  },
  data() {
    return {
      orderList: [],
      loadingSkeleton: true,
      refreshing: false,
      selectedItem: null,
      pageSize: 1000,
      currentPage: 1
    }
  },
  mounted() {
    this.getMyOrder()
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.back()
    },

    // 获取订单列表
    async getMyOrder() {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        const { result, resultCode } = await orderQueryMy({
          cjr: userInfo.yhid,
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })

        if (resultCode === 200) {
          this.orderList = result.list || []
        } else {
          Toast('获取订单列表失败')
        }
      } catch (error) {
        console.error('获取订单列表失败', error)
        Toast('获取订单列表失败，请重试')
      } finally {
        this.loadingSkeleton = false
        this.refreshing = false
      }
    },

    // 刷新列表
    async onRefresh() {
      await this.getMyOrder()
    },

    // 重新加载列表（供支付弹窗调用）
    loadOrderList() {
      this.getMyOrder()
    },

    // 获取订单状态文本
    getStatusText(status) {
      const statusMap = {
        1: '未支付',
        2: '已支付',
        3: '已取消'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取订单状态样式类
    getStatusClass(status) {
      const classMap = {
        1: 'status-unpaid',
        2: 'status-paid',
        3: 'status-cancelled'
      }
      return classMap[status] || ''
    },

    // 获取会员天数
    getMemberDays(spmc) {
      const daysMap = {
        '月体验会员': 30,
        '7天会员': 7,
        '包月会员': 30,
        '包季会员': 90,
        '包年会员': 365,
        '3年会员': 1095
      }
      return daysMap[spmc] || 0
    },

    // 格式化日期
    formatDate(dateTime) {
      if (dateTime) {
        return new Date(dateTime).toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
      }
      return ''
    },

    // 处理支付
    handlePayment(order) {
      const obj = {
        hymc: order.spmc,
        hyjg: order.spjg,
        ddid: order.ddid
      }
      localStorage.setItem('ddids', order.ddid)
      this.selectedItem = obj

      // 打开支付弹窗并设置订单信息
      const payDialog = this.$refs.payDialog
      if (payDialog) {
        payDialog.show = true
        payDialog.orderConfirmed = true
        payDialog.orderNo = order.ddbh
        payDialog.creationDate = order.cjrq
        payDialog.getAlipay(order.ddbh, order.spjg)
        payDialog.getWeiChatPay(order.ddbh, order.spjg)
        payDialog.startPaymentStatusPolling(order.ddid)
      }
    },

    // 取消订单
    handleCancel(order) {
      Dialog.confirm({
        title: '提示',
        message: '确定要取消该订单吗？',
        confirmButtonText: '确定取消',
        cancelButtonText: '再想想'
      }).then(() => {
        this.updateOrderStatus(order, 3, 0)
      }).catch(() => {
        // 用户取消操作
      })
    },

    // 删除订单
    handleDelete(order) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除该订单吗？',
        confirmButtonText: '确定删除',
        cancelButtonText: '取消'
      }).then(() => {
        this.updateOrderStatus(order, order.ddzt, 1)
      }).catch(() => {
        // 用户取消操作
      })
    },

    // 再次购买
    againPay() {
      this.$router.push('/vipCenter')
    },

    // 更新订单状态
    async updateOrderStatus(order, ddzt, scbj) {
      try {
        const { resultCode, resultDesc } = await orderUpdate({
          ddid: order.ddid,
          ddzt: ddzt,
          scbj: scbj
        })

        if (resultCode === 200) {
          const message = scbj === 0 ? '取消成功' : '删除成功'
          Toast.success(message)
          await this.getMyOrder()
        } else {
          Toast(resultDesc || '操作失败')
        }
      } catch (error) {
        console.error('更新订单状态失败', error)
        Toast('操作失败，请重试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-list-page {
  min-height: 100vh;
  background: #F5F7FA;

  .order-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    z-index: 100;

    i {
      font-size: 20px;
      cursor: pointer;
      color: #333;

      &:hover {
        color: #00D090;
      }
    }

    .header-title {
      flex: 1;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      color: #333;
    }
  }

  .order-content {
    padding-top: 50px;
    padding-bottom: 20px;
  }

  .skeleton-list {
    padding: 12px;

    .skeleton-item {
      background: #fff;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 12px;
    }
  }

  .order-list {
    padding: 12px;
  }

  .order-card {
    background: #fff;
    border-radius: 12px;
    margin-bottom: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: transform 0.2s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 16px 12px;

      .order-name {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }

      .order-status {
        font-size: 13px;
        padding: 2px 8px;
        border-radius: 12px;

        &.status-unpaid {
          color: #FF9800;
          background: rgba(255, 152, 0, 0.1);
        }

        &.status-paid {
          color: #00D090;
          background: rgba(0, 208, 144, 0.1);
        }

        &.status-cancelled {
          color: #999;
          background: rgba(153, 153, 153, 0.1);
        }
      }
    }

    .card-divider {
      height: 1px;
      background: #F0F0F0;
      margin: 0 16px;
    }

    .card-body {
      padding: 12px 16px;

      .info-row {
        display: flex;
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }

        .info-label {
          width: 70px;
          font-size: 13px;
          color: #999;
        }

        .info-value {
          flex: 1;
          font-size: 13px;
          color: #666;

          &.price {
            color: #FF9800;
            font-weight: 500;
            font-size: 14px;
          }
        }
      }
    }

    .card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;

      .order-time {
        font-size: 12px;
        color: #999;
      }

      .action-buttons {
        display: flex;
        gap: 8px;

        .pay-btn {
          background: linear-gradient(135deg, #05D5B8, #258CF2);
          border: none;
          border-radius: 16px;
          padding: 0 16px;
          height: 28px;
          font-size: 12px;
          color: #fff;

          &:hover {
            opacity: 0.9;
          }
        }

        .cancel-btn {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 16px;
          padding: 0 16px;
          height: 28px;
          font-size: 12px;
          color: #666;

          &:hover {
            border-color: #FF9800;
            color: #FF9800;
          }
        }

        .buy-again-btn {
          background: #fff;
          border: 1px solid #00D090;
          border-radius: 16px;
          padding: 0 16px;
          height: 28px;
          font-size: 12px;
          color: #00D090;

          &:hover {
            background: rgba(0, 208, 144, 0.05);
          }
        }

        .delete-btn {
          background: #fff;
          border: 1px solid #FF4D4F;
          border-radius: 16px;
          padding: 0 16px;
          height: 28px;
          font-size: 12px;
          color: #FF4D4F;

          &:hover {
            background: rgba(255, 77, 79, 0.05);
          }
        }
      }
    }
  }

  .empty-state {
    padding-top: 100px;
    background: transparent;
  }
}

// 响应式
@media (max-width: 768px) {
  .order-list-page {
    .order-card {
      .card-footer {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;

        .order-time {
          order: 2;
        }

        .action-buttons {
          order: 1;
          width: 100%;
          justify-content: flex-end;
        }
      }
    }
  }
}
</style>
